
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!Pricing/PricingChangeTierComponent',['require','translate','react','jquery','underscore','lib/react/React.PodioView','component!ModalComponent','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Routes','lib/Podio.Utils','classnames'],function (require) {
  'use strict';

  var t = require('translate');
  var React = require('react');
  var $ = require('jquery');
  var _ = require('underscore');
  var PodioView = require('lib/react/React.PodioView');

  var ModalComponent = require('component!ModalComponent');

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');

  var routes = require('lib/Podio.Routes');
  var utils = require('lib/Podio.Utils');

  var PricingChangeTierComponent = PodioView.extend({
    displayName: 'PricingChangeTierComponent',

    getDefaultProps: function getDefaultProps() {
      return {
        tier: null,
        isUpgrade: false,
        contract: null
      };
    },

    getInitialState: function getInitialState() {
      this.modal = React.createRef();
      return {
        isLoading: false
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var self = this;

      utils.getOrgByUrlLabel().then(function (organization) {
        self.setState({
          organization: organization
        });

        if (_.isNull(self.props.contract)) {
          utils.getContractByOrg().done(function (contract) {
            self.setState({
              contract: contract
            });
          });
        }
      });
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'pricing-change-tier-component' },
        React.createElement(
          ModalComponent,
          _extends({ ref: this.modal }, this.props),
          this.renderCopy()
        )
      );
    },

    renderCopy: function renderCopy() {
      if (this.props.tier === null) {
        return;
      }

      var cx = require('classnames');

      var classSet = cx({
        'button-new': true,
        'primary': true,
        'loader': this.state.isLoading
      });

      return React.createElement(
        'div',
        { className: 'modal-content' },
        React.createElement(
          'p',
          null,
          t('Are you sure you want to {0} to {1}? #tier.change').format(this.props.isUpgrade ? t('upgrade #tier.change') : t('downgrade #tier.change'), this.props.tier.humanized_name)
        ),
        React.createElement(
          'span',
          null,
          this.props.isUpgrade ? t('Upgrading will enable {0} features for the members of your organisation. #tier.change').format(this.props.tier.humanized_name) : t('Members in your organisation will no longer be able to use {0} features. #tier.change').format(this.props.contract.tier)
        ),
        React.createElement(
          'p',
          null,
          React.createElement(
            'button',
            { className: classSet, onClick: this.handleConfirmClick },
            this.props.isUpgrade ? t('upgrade #tier.change') : t('downgrade #tier.change')
          )
        )
      );
    },

    handleConfirmClick: function handleConfirmClick() {
      this.setState({
        isLoading: true
      });

      this._updateContract().done(this._redirect());
    },

    _updateContract: function _updateContract() {
      var contractId;
      if (!_.isNull(this.props.contract)) {
        contractId = this.props.contract.contract_id;
      } else if (this.state.contract) {
        contractId = this.state.contract.contract_id;
      }

      var formattedTier = this.props.tier.humanized_name.toLowerCase();
      var requestData = {
        tier: formattedTier
      };

      return API.request('PUT', '/contract/{0}'.format(contractId), requestData);
    },

    _redirect: function _redirect() {
      var method = this.props.isUpgrade ? 'organization_pricing_plan_upgraded_path' : 'organization_pricing_plan_downgraded_path';

      window.location.href = routes[method](this.state.organization.url_label, this.props.tier.humanized_name.toLowerCase(), {
        wasDowngraded: this.props.isUpgrade === false,
        format: 'html'
      });
    },

    open: function open() {
      this.modal.current.open();
    },

    close: function close() {
      this.modal.current.close();
    }
  });

  return PricingChangeTierComponent;
});
